import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './auth/login/login.component';
import {AppAccessDeniedComponent} from "./core/content/app-access-denied/app-access-denied.component";
import {AppSignedOutComponent} from "./core/content/app-signed-out/app-signed-out.component";

export const AppRoutes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'access-denied', component: AppAccessDeniedComponent },
  { path: 'signed-out', component: AppSignedOutComponent }  
  // otherwise redirect to home
  // { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(AppRoutes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
